// Core
import styled from 'styled-components';

/* ************** MODEL CONTAINER ******************* */

export const ModelContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.color.crusherDashboard.maintenance.borderColor};
  border-radius: 4px;
  margin-right: 16px;
  height: 100%;
`;

export const ModelTitle = styled.div`
  padding: 16px 16px 0 16px;
`;

export const ModelBackgroundContainer = styled.div<{ running?: boolean }>`
  background: ${({
    running = true,
    theme,
  }) => (running
    ? theme.color.crusherDashboard.maintenance.setup.information.modelBackgroundColor
    : theme.color.crusherDashboard.maintenance.setup.information.modelBackgroundColorOff
  )};
  border-radius: 4px;
  height: 39px;
  margin: 16px;
`;

export const ModelContentWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  padding: 16px;
`;

/* ************** QUANTITY CONTAINER ******************* */

export const QuantityContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.color.crusherDashboard.maintenance.borderColor};
  border-radius: 4px;
`;

export const QuantityTitle = styled.div`
  padding: 16px 16px 0 16px;
`;

export const QuantityContent = styled.div`
  padding: 16px 8px 16px 16px;
`;

export const QuantityCardContainer = styled.div`
  margin-right: 10px;
`;
